"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("./types");
var _utils = require("../../utils");
/**
 * This action should _NOT_ be called directly by UI interaction. This is called when the Chime SDK
 * notifies us that an attendee's mute status has changed. For setting mute status based on a UI
 * interaction, please use setDesiredAttendeeMuteStatus.
 */
function setAttendeeMuteStatus(attendeeId, isMuted) {
  return (0, _utils.actionCreator)(_types.BROADCAST_SET_ATTENDEE_MUTE_STATUS, {
    attendeeId: attendeeId,
    isMuted: isMuted
  });
}
var _default = exports["default"] = setAttendeeMuteStatus;